if (!customElements.get("redirection-popup")) {
  customElements.define(
    "redirection-popup",
    class RedirectionPopup extends HTMLElement {
      constructor() {
        super();
        this.cookieName = "localePopup";
        this.isCookieSet = false;

        this.storeUrl = this.dataset.requestOrigin;
        this.ukStoreUrl = this.dataset.ukUrl;
        this.euStoreUrl = this.dataset.euUrl;
        this.globalStoreUrl = this.dataset.globalUrl || this.ukStoreUrl || this.euStoreUrl;

        this.currStoreUrl = window.shopUrl.replace(/^https?:\/\//, '').replace('/', '');
        this.currStoreCountry = window.Shopify.country;

        this.cacheDOMElements();

        this.userLocale = "";
        this.userlocaleData = {};
        this.redirectList = [
          { user_country_name: "United Kingdom", user_country_code: "GB" },
          { user_country_name: "United States", user_country_code: "US" },
          { user_country_name: "Australia", user_country_code: "AU" },
          { user_country_name: "Albania", user_country_code: "AL" },
          { user_country_name: "Algeria", user_country_code: "DZ" },
          { user_country_name: "Andorra", user_country_code: "AD" },
          { user_country_name: "Angola", user_country_code: "AO" },
          { user_country_name: "Anguilla", user_country_code: "AI" },
          { user_country_name: "Antigua & Barbuda", user_country_code: "AG" },
          { user_country_name: "Argentina", user_country_code: "AR" },
          { user_country_name: "Armenia", user_country_code: "AM" },
          { user_country_name: "Aruba", user_country_code: "AW" },
          { user_country_name: "Austria", user_country_code: "AT" },
          { user_country_name: "Azerbaijan", user_country_code: "AZ" },
          { user_country_name: "Bahamas", user_country_code: "BS" },
          { user_country_name: "Bahrain", user_country_code: "BH" },
          { user_country_name: "Bangladesh", user_country_code: "BD" },
          { user_country_name: "Barbados", user_country_code: "BB" },
          { user_country_name: "Belgium", user_country_code: "BE" },
          { user_country_name: "Belize", user_country_code: "BZ" },
          { user_country_name: "Benin", user_country_code: "BJ" },
          { user_country_name: "Bermuda", user_country_code: "BM" },
          { user_country_name: "Bhutan", user_country_code: "BT" },
          { user_country_name: "Bolivia", user_country_code: "BO" },
          { user_country_name: "Bosnia & Herzegovina", user_country_code: "BA" },
          { user_country_name: "Botswana", user_country_code: "BW" },
          { user_country_name: "Brazil", user_country_code: "BR" },
          { user_country_name: "British Virgin Islands", user_country_code: "VG" },
          { user_country_name: "Brunei", user_country_code: "BN" },
          { user_country_name: "Bulgaria", user_country_code: "BG" },
          { user_country_name: "Burkina Faso", user_country_code: "BF" },
          { user_country_name: "Burundi", user_country_code: "BI" },
          { user_country_name: "Cambodia", user_country_code: "KH" },
          { user_country_name: "Cameroon", user_country_code: "CM" },
          { user_country_name: "Canada", user_country_code: "CA" },
          { user_country_name: "Cape Verde", user_country_code: "CV" },
          { user_country_name: "Cayman Islands", user_country_code: "KY" },
          { user_country_name: "Chad", user_country_code: "TD" },
          { user_country_name: "Chile", user_country_code: "CL" },
          { user_country_name: "Colombia", user_country_code: "CO" },
          { user_country_name: "Comoros", user_country_code: "KM" },
          { user_country_name: "Congo - Brazzaville", user_country_code: "CG" },
          { user_country_name: "Cook Islands", user_country_code: "CK" },
          { user_country_name: "Costa Rica", user_country_code: "CR" },
          { user_country_name: "Côte d’Ivoire", user_country_code: "CI" },
          { user_country_name: "Croatia", user_country_code: "HR" },
          { user_country_name: "Curaçao", user_country_code: "CW" },
          { user_country_name: "Cyprus", user_country_code: "CY" },
          { user_country_name: "Czechia", user_country_code: "CZ" },
          { user_country_name: "Denmark", user_country_code: "DK" },
          { user_country_name: "Djibouti", user_country_code: "DJ" },
          { user_country_name: "Dominica", user_country_code: "DM" },
          { user_country_name: "Dominican Republic", user_country_code: "DO" },
          { user_country_name: "Ecuador", user_country_code: "EC" },
          { user_country_name: "Egypt", user_country_code: "EG" },
          { user_country_name: "El Salvador", user_country_code: "SV" },
          { user_country_name: "Equatorial Guinea", user_country_code: "GQ" },
          { user_country_name: "Equatorial Guinea", user_country_code: "GQ" },
          { user_country_name: "Eritrea", user_country_code: "ER" },
          { user_country_name: "Estonia", user_country_code: "EE" },
          { user_country_name: "Eswatini", user_country_code: "SZ" },
          { user_country_name: "Ethiopia", user_country_code: "ET" },
          { user_country_name: "Falkland Islands", user_country_code: "FK" },
          { user_country_name: "Faroe Islands", user_country_code: "FO" },
          { user_country_name: "Fiji", user_country_code: "FJ" },
          { user_country_name: "Finland", user_country_code: "FI" },
          { user_country_name: "France", user_country_code: "FR" },
          { user_country_name: "French Guiana", user_country_code: "GF" },
          { user_country_name: "French Polynesia", user_country_code: "PF" },
          { user_country_name: "Gabon", user_country_code: "GA" },
          { user_country_name: "Gambia", user_country_code: "GM" },
          { user_country_name: "Georgia", user_country_code: "GE" },
          { user_country_name: "Germany", user_country_code: "DE" },
          { user_country_name: "Ghana", user_country_code: "GH" },
          { user_country_name: "Gibraltar", user_country_code: "GI" },
          { user_country_name: "Greece", user_country_code: "GR" },
          { user_country_name: "Greenland", user_country_code: "GL" },
          { user_country_name: "Grenada", user_country_code: "GD" },
          { user_country_name: "Guadeloupe", user_country_code: "GP" },
          { user_country_name: "Guatemala", user_country_code: "GT" },
          { user_country_name: "Guinea", user_country_code: "GN" },
          { user_country_name: "Guinea-Bissau", user_country_code: "GW" },
          { user_country_name: "Guyana", user_country_code: "GY" },
          { user_country_name: "Haiti", user_country_code: "HT" },
          { user_country_name: "Honduras", user_country_code: "HN" },
          { user_country_name: "Hong Kong SAR China", user_country_code: "HK" },
          { user_country_name: "Hungary", user_country_code: "HU" },
          { user_country_name: "Iceland", user_country_code: "IS" },
          { user_country_name: "India", user_country_code: "IN" },
          { user_country_name: "Indonesia", user_country_code: "ID" },
          { user_country_name: "Iraq", user_country_code: "IQ" },
          { user_country_name: "Ireland", user_country_code: "IE" },
          { user_country_name: "Israel", user_country_code: "IL" },
          { user_country_name: "Italy", user_country_code: "IT" },
          { user_country_name: "Jamaica", user_country_code: "JM" },
          { user_country_name: "Japan", user_country_code: "JP" },
          { user_country_name: "Jordan", user_country_code: "JO" },
          { user_country_name: "Kazakhstan", user_country_code: "KZ" },
          { user_country_name: "Kenya", user_country_code: "KE" },
          { user_country_name: "Kiribati", user_country_code: "KI" },
          { user_country_name: "Kosovo", user_country_code: "XK" },
          { user_country_name: "Kuwait", user_country_code: "KW" },
          { user_country_name: "Kyrgyzstan", user_country_code: "KG" },
          { user_country_name: "Laos", user_country_code: "LA" },
          { user_country_name: "Latvia", user_country_code: "LV" },
          { user_country_name: "Lebanon", user_country_code: "LB" },
          { user_country_name: "Lesotho", user_country_code: "LS" },
          { user_country_name: "Liberia", user_country_code: "LR" },
          { user_country_name: "Libya", user_country_code: "LY" },
          { user_country_name: "Liechtenstein", user_country_code: "LI" },
          { user_country_name: "Lithuania", user_country_code: "LT" },
          { user_country_name: "Luxembourg", user_country_code: "LU" },
          { user_country_name: "Macau SAR China", user_country_code: "MO" },
          { user_country_name: "Madagascar", user_country_code: "MG" },
          { user_country_name: "Malawi", user_country_code: "MW" },
          { user_country_name: "Malaysia", user_country_code: "MY" },
          { user_country_name: "Maldives", user_country_code: "MV" },
          { user_country_name: "Mali", user_country_code: "ML" },
          { user_country_name: "Malta", user_country_code: "MT" },
          { user_country_name: "Martinique", user_country_code: "MQ" },
          { user_country_name: "Mauritania", user_country_code: "MR" },
          { user_country_name: "Mauritius", user_country_code: "MU" },
          { user_country_name: "Mayotte", user_country_code: "YT" },
          { user_country_name: "Mexico", user_country_code: "MX" },
          { user_country_name: "Moldova", user_country_code: "MD" },
          { user_country_name: "Monaco", user_country_code: "MC" },
          { user_country_name: "Mongolia", user_country_code: "MN" },
          { user_country_name: "Montenegro", user_country_code: "ME" },
          { user_country_name: "Montserrat", user_country_code: "MS" },
          { user_country_name: "Morocco", user_country_code: "MA" },
          { user_country_name: "Mozambique", user_country_code: "MZ" },
          { user_country_name: "Namibia", user_country_code: "NA" },
          { user_country_name: "Nauru", user_country_code: "NR" },
          { user_country_name: "Nepal", user_country_code: "NP" },
          { user_country_name: "Netherlands", user_country_code: "NL" },
          { user_country_name: "New Caledonia", user_country_code: "NC" },
          { user_country_name: "New Zealand", user_country_code: "NZ" },
          { user_country_name: "Nicaragua", user_country_code: "NI" },
          { user_country_name: "Niger", user_country_code: "NE" },
          { user_country_name: "Nigeria", user_country_code: "NG" },
          { user_country_name: "Niue", user_country_code: "NU" },
          { user_country_name: "Norfolk Island", user_country_code: "NF" },
          { user_country_name: "North Macedonia", user_country_code: "MK" },
          { user_country_name: "Norway", user_country_code: "NO" },
          { user_country_name: "Oman", user_country_code: "OM" },
          { user_country_name: "Pakistan", user_country_code: "PK" },
          { user_country_name: "Palau", user_country_code: "PW" },
          { user_country_name: "Palestinian Territories", user_country_code: "PS" },
          { user_country_name: "Panama", user_country_code: "PA" },
          { user_country_name: "Papua New Guinea", user_country_code: "PG" },
          { user_country_name: "Paraguay", user_country_code: "PY" },
          { user_country_name: "Peru", user_country_code: "PE" },
          { user_country_name: "Philippines", user_country_code: "PH" },
          { user_country_name: "Pitcairn Islands", user_country_code: "PN" },
          { user_country_name: "Poland", user_country_code: "PL" },
          { user_country_name: "Portugal", user_country_code: "PT" },
          { user_country_name: "Qatar", user_country_code: "QA" },
          { user_country_name: "Réunion", user_country_code: "RE" },
          { user_country_name: "Romania", user_country_code: "RO" },
          { user_country_name: "Russia", user_country_code: "RU" },
          { user_country_name: "Rwanda", user_country_code: "RW" },
          { user_country_name: "Samoa", user_country_code: "WS" },
          { user_country_name: "San Marino", user_country_code: "SM" },
          { user_country_name: "São Tomé & Príncipe", user_country_code: "ST" },
          { user_country_name: "Saudi Arabia", user_country_code: "SA" },
          { user_country_name: "Senegal", user_country_code: "SN" },
          { user_country_name: "Serbia", user_country_code: "RS" },
          { user_country_name: "Seychelles", user_country_code: "SC" },
          { user_country_name: "Sierra Leone", user_country_code: "SL" },
          { user_country_name: "Singapore", user_country_code: "SG" },
          { user_country_name: "Sint Maarten", user_country_code: "SX" },
          { user_country_name: "Slovakia", user_country_code: "SK" },
          { user_country_name: "Slovenia", user_country_code: "SI" },
          { user_country_name: "Solomon Islands", user_country_code: "SB" },
          { user_country_name: "Somalia", user_country_code: "SO" },
          { user_country_name: "South Africa", user_country_code: "ZA" },
          { user_country_name: "South Korea", user_country_code: "KR" },
          { user_country_name: "South Sudan", user_country_code: "SS" },
          { user_country_name: "Spain", user_country_code: "ES" },
          { user_country_name: "Sri Lanka", user_country_code: "LK" },
          { user_country_name: "St. Barthélemy", user_country_code: "BL" },
          { user_country_name: "St. Helena", user_country_code: "SH" },
          { user_country_name: "St. Kitts & Nevis", user_country_code: "KN" },
          { user_country_name: "St. Lucia", user_country_code: "LC" },
          { user_country_name: "St. Martin", user_country_code: "MF" },
          { user_country_name: "St. Pierre & Miquelon", user_country_code: "PM" },
          { user_country_name: "St. Vincent & Grenadines", user_country_code: "VC" },
          { user_country_name: "Sudan", user_country_code: "SD" },
          { user_country_name: "Suriname", user_country_code: "SR" },
          { user_country_name: "Sweden", user_country_code: "SE" },
          { user_country_name: "Switzerland", user_country_code: "CH" },
          { user_country_name: "Syria", user_country_code: "SY" },
          { user_country_name: "Taiwan", user_country_code: "TW" },
          { user_country_name: "Tajikistan", user_country_code: "TJ" },
          { user_country_name: "Tanzania", user_country_code: "TZ" },
          { user_country_name: "Thailand", user_country_code: "TH" },
          { user_country_name: "Timor-Leste", user_country_code: "TL" },
          { user_country_name: "Togo", user_country_code: "TG" },
          { user_country_name: "Tokelau", user_country_code: "TK" },
          { user_country_name: "Tonga", user_country_code: "TO" },
          { user_country_name: "Trinidad & Tobago", user_country_code: "TT" },
          { user_country_name: "Tunisia", user_country_code: "TN" },
          { user_country_name: "Turkey", user_country_code: "TR" },
          { user_country_name: "Turkmenistan", user_country_code: "TM" },
          { user_country_name: "Turks & Caicos Islands", user_country_code: "TC" },
          { user_country_name: "Tuvalu", user_country_code: "TV" },
          { user_country_name: "U.S. Outlying Islands", user_country_code: "UM" },
          { user_country_name: "U.S. Virgin Islands", user_country_code: "VI" },
          { user_country_name: "Ukraine", user_country_code: "UA" },
          { user_country_name: "United Arab Emirates", user_country_code: "AE" },
          { user_country_name: "Uruguay", user_country_code: "UY" },
          { user_country_name: "Uzbekistan", user_country_code: "UZ" },
          { user_country_name: "Vanuatu", user_country_code: "VU" },
          { user_country_name: "Vatican City", user_country_code: "VA" },
          { user_country_name: "Venezuela", user_country_code: "VE" },
          { user_country_name: "Vietnam", user_country_code: "VN" },
          { user_country_name: "Wallis & Futuna", user_country_code: "WF" },
          { user_country_name: "Western Sahara", user_country_code: "EH" },
          { user_country_name: "Yemen", user_country_code: "YE" },
          { user_country_name: "Zambia", user_country_code: "ZM" },
          { user_country_name: "Zimbabwe", user_country_code: "ZW" },
        ];

        this.euCountryCodes = ["AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR",
                               "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL",
                               "PL", "PT", "RO", "SK", "SI", "ES", "SE"];

        this.assignRedirectURLs();
        this.init();
      }

      cacheDOMElements() {
        this.closeButton = this.querySelector(".redirection-popup-close");
        this.countryName = this.querySelector(".user-country-name");
        this.redirectButton = this.querySelector("#locale-redirect-to");
        this.redirectAlternateButton = this.querySelector("#locale-redirect-to-alternate");
        this.stayButton = this.querySelector("#locale-stay");
        this.redirectionStoreFlag = this.querySelector("#locale-redirect-to .flag-icon");
        this.redirectButtonText = this.redirectButton?.querySelector("#countryRedirectTo") || this.redirectButton;
        this.stayButtonText = this.stayButton?.querySelector("#countryStay") || this.stayButton;
      }

      assignRedirectURLs() {
        this.redirectList.forEach(country => {
          if (country.user_country_code === "GB") {
            country.redirectURL = this.ukStoreUrl;
          } else if (this.euCountryCodes.includes(country.user_country_code)) {
            country.redirectURL = this.euStoreUrl;
          } else {
            country.redirectURL = this.globalStoreUrl;
          }
        });
      }

      connectedCallback() {
        this.closeButton.addEventListener("click", this.handleClose.bind(this));
        this.stayButton.addEventListener("click", this.handleStay.bind(this));
        this.redirectButton.addEventListener("click", this.handleRedirect.bind(this));
        this.addEventListener("click", this.handleStay.bind(this));
        this.redirectAlternateButton?.addEventListener("click", this.handleRedirect.bind(this));
      }

      async init() {
        if (this.getCookie(this.cookieName) === "shown") return;

        await this.checkRegion();

        if (!this.shouldShowPopup()) return;

        this.updatePopupContent();
        this.open();
      }

      async checkRegion() {
        try {
          const response = await fetch("/browsing_context_suggestions.json");
          const responseJson = await response.json();
          this.userLocale = responseJson?.detected_values?.country?.handle;
          this.userlocaleData = this.redirectList.find(item => item.user_country_code === this.userLocale) || {};
        } catch (error) {
          console.error("Failed to fetch region data", error);
        }
      }

      getVisitorLocation() {
        return this.userlocaleData.redirectURL === this.euStoreUrl ? "EU" : "GB";
      }

      getCurrentStore() {
        if (this.currStoreUrl.includes(this.ukStoreUrl)) {
          return "GB";
        } else if (this.currStoreUrl.includes(this.euStoreUrl)) {
          return "EU";
        }
      }

      getVisitRedirectObject() {
        const currentStore = this.getCurrentStore();
        const visitorLocation = this.getVisitorLocation();

        const redirectObject = {
          stay: {
            url: currentStore === "GB" ? this.ukStoreUrl : this.euStoreUrl,
            text: currentStore === "GB" ? "United Kingdom" : "Europe",
            abbreviation: currentStore === "GB" ? "UK" : "EU",
          },
          redirect_to: {},
        };

        if (currentStore === "GB" && visitorLocation === "EU") {
          redirectObject.redirect_to = {
            url: this.euStoreUrl,
            text: "Europe",
            abbreviation: "EU",
          };
        } else if (currentStore === "EU") {
          if (visitorLocation === "GB") {
            redirectObject.redirect_to = {
              url: this.ukStoreUrl,
              text: "United Kingdom",
              abbreviation: "UK",
            };
          } else if (visitorLocation === "US") {
            redirectObject.redirect_to = {
              url: this.euStoreUrl,
              text: "Europe",
              abbreviation: "EU",
            };
          }
        }

        if (!redirectObject.redirect_to.url) {
          redirectObject.redirect_to = {
            url: this.ukStoreUrl,
            text: "United Kingdom",
            abbreviation: "UK",
          };
        }

        return redirectObject;
      }

      updatePopupContent() {
        const redirectObject = this.getVisitRedirectObject();

        this.countryName.innerText = this.userlocaleData.user_country_name;
        this.redirectButton.setAttribute("href", `https://${redirectObject.redirect_to.url}`);
        this.stayButtonText.innerText = redirectObject.stay.abbreviation;
        this.redirectButtonText.innerText = redirectObject.redirect_to.abbreviation;
      }

      shouldShowPopup() {
        return this.userLocale && this.redirectList.some(item =>
          item.user_country_code === this.userLocale && this.currStoreUrl.replace(/^www\./, '') !== item.redirectURL.replace(/^www\./, '')
        );
      }

      open() {
        this.classList.add("show");
      }

      close() {
        this.classList.remove("show");
      }

      handleClose() {
        this.setCookie(this.cookieName, "shown", 60);
        document.querySelector('currency-drawer-button').click();
        this.close();
      }

      handleStay(event) {
        event.preventDefault();
        this.setCookie(this.cookieName, "shown", 60);
        document.querySelector('currency-drawer-button').click();
        this.close();
        event.stopPropagation();
      }

      handleRedirect(event) {
        event.preventDefault();
        this.setCookie(this.cookieName, "shown", 60);

        const href = document.getElementById("locale-redirect-to").getAttribute("href");
        window.location = href;
      }

      setCookie(cName, cValue, expDays) {
        const date = new Date();
        date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + date.toUTCString();
        document.cookie = `${cName}=${cValue}; ${expires}; path=/`;
      }

      getCookie(cookieName) {
        const cookieString = document.cookie;
        const cookies = cookieString.split("; ");
        const cookie = cookies.find(row => row.startsWith(`${cookieName}=`));
        return cookie ? decodeURIComponent(cookie.split('=')[1]) : null;
      }
    }
  );
}
